var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"home"}},[_c('main-template',{attrs:{"showBanner":true}},[_c('condition',[[_c('paper-list')]],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }